// 给footer标题注册点击事件
document.querySelectorAll(".footer__blocks-wrapper .footer-block:has(.list-menu__item--link) .footer-block__heading").forEach((item) => {
    item.addEventListener("click", () => {
        item.classList.toggle("open");
    }); 
});

// 国家选择器注册点击事件
document.querySelector(".change-country-wrapper .open-country").addEventListener("click", () => {
    document.querySelector(".change-country-wrapper .country-selector").classList.toggle("open");
});
document.querySelector(".change-country-wrapper .close-button").addEventListener("click", () => {
    document.querySelector(".change-country-wrapper .country-selector").classList.toggle("open");
});